import { isMobile, X_Language } from '@/utils';
import day from 'dayjs';
import Tracker from './tracker';

class ProductTracker extends Tracker {
  /*
   *
   * @desc: 产品页公共埋点
   * @param {string} action 事件操作
   * @param {object} productState 产品状态
   *
   */
  productPage = ({ action, label = '', productState, data = {}, video = {} }) => {
    if (!productState) return;
    let value = '';
    try {
      const { productDetail = {}, curSelectCommodityId, curSelectCommodity, text } = productState;
      const { from } = data;
      const { commodities, url_key, VersionConfig } = productDetail;
      const commodity = commodities?.filter((o) => o.id === curSelectCommodityId)[0] || curSelectCommodity;
      switch (action) {
        case 'commodity_select':
        case 'stock_notice':
        case 'quantity_add':
        case 'quantity_minus':
        case 'quantity_input':
        case 'show_productlist':
          label = `${url_key}_${commodity.name}(${commodity.id})`;
          break;
        case 'spec_select':
          label = `${url_key}_${
            commodity.info.name?.split('||')?.[VersionConfig.versionIndex || 0] ?? commodity.name
          }(${commodity.id})`;
          break;
        case 'add_to_cart':
          label = `${url_key}_${commodity.info.name?.split('||')?.[0] ?? commodity.name}(${commodity.id})_${from}`;
          break;
        case 'help_email_click':
        case 'tradeup_click':
        case 'pro_camera_discount_click':
        case 'intro_open':
        case 'intro_close':
        case 'detail_open':
        case 'detail_close':
          label = `${url_key}`;
          break;
        case 'videos_play':
        case 'videos_close':
        case 'overview_video_play':
        case 'overview_video_close':
        case 'overview_video_pause':
        case 'overview_video_mute':
        case 'overview_video_unmute':
        case 'overview_video_enter_fullscreen':
        case 'overview_video_exit_fullscreen':
          label = `${url_key}_(${video.label})`;
          break;
        case 'overview_video_change_volume':
          label = `${url_key}_(${video.label})`;
          value = video.volume;
          break;
        case 'footnote_hover':
          label = text;
          break;
        case 'recommend_page_change':
        case 'recommend_add_to_cart':
        case 'recommend_stock_notice':
          break;
        default:
          label = label || `${url_key}`;
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页主图埋点
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  productPageImages = ({ action, data = {}, category }) => {
    try {
      let label = '';
      let sec_action = '';
      switch (action) {
        case 'click_image':
        case 'click_thumbnail':
        case 'hover_thumbnail':
        case 'expose_image':
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张`;
          break;
        case 'video_play':
        case 'video_end':
        case 'video_expose':
          label = `${data.videoInnerName}_${data?.url_key}_${data?.name}(${data?.id})`;
          break;
        case 'click_thumbnail_pop':
          sec_action = 'click_thumbnail';
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张`;
          break;
        case 'expose_image_pop':
          sec_action = 'expose_image';
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张`;
          break;
        case 'enlarge_image':
          label = `${data?.url_key}_${data?.name}(${data?.id})`;
          break;
        case 'expose_image_scene':
        case 'expose_image_pop_scene':
          sec_action = 'expose_image';
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张_场景图`;
          break;
        case 'click_image_scene':
          sec_action = 'click_image';
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张_场景图`;
          break;
        case 'click_thumbnail_scene':
          sec_action = 'click_thumbnail';
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张_场景图`;
          break;
        case 'click_thumbnail_accessories':
        case 'hover_thumbnail_accessories':
          label = `${data?.url_key}_${data?.name}(${data?.id})_第${data?.imageIndex}张_缩略图`;
          break;
        case 'click_fourangle_button':
        case 'click_scene_button':
        case 'click_item_button':
        case 'click_360_button':
        case 'click_video2_button':
        case 'image_drag_angle':
        case 'click_scene_point':
        case 'angle_replay_btn_click':
        case 'scenario_replay_btn_click':
        case 'click_accessory_tab':
          label = `${data?.url_key}_${data?.name}(${data?.id})`;
          break;

        default:
          label = '';
      }

      this.commonTracker({
        category: category || `${isMobile() ? 'mobile' : 'pc'}_product_image`,
        action: sec_action || action,
        label,
        value: '',
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页详情二级菜单埋点
   * @param {string} action 事件操作
   * @param {object} productState 产品状态
   *
   */
  productPageSubMenu = ({ action, productState, value: _value = '' }) => {
    if (!productState) return;
    let time = '';
    let label = '';
    let value = _value || '';
    try {
      const { productDetail } = productState;
      const { url_key } = productDetail;
      switch (action) {
        default:
          label = `${url_key}`;
          break;
      }
      // 针对评论导航特殊处理
      if (action === 'view_comments') {
        time = day().format('YYYY-MM-DD HH:mm:ss');
        label = `${url_key} + ${X_Language} + ${time}`;
        this.commonTracker({
          category: `${isMobile() ? 'mobile' : 'pc'}_comments_productPage`,
          action,
          label,
          value,
        });
      } else {
        this.commonTracker({
          category: `${isMobile() ? 'mobile' : 'pc'}_product_page_sub_menu`,
          action,
          label,
          value,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页绑定服务加购模块（care/延保）埋点
   * @param {string} action 事件操作
   * @param {object} productState 产品状态
   * @param {object} serviceItem 绑定服务item
   *
   */
  productPageBindService = ({ action, productState, serviceItem }) => {
    if (!productState) return;
    let label = '';
    let value = '';
    try {
      const { productDetail, curSelectCommodityId } = productState;
      const { url_key, commodities } = productDetail;
      const commodity = commodities.filter((o) => o.id === curSelectCommodityId)[0];
      switch (action) {
        case 'add':
        case 'remove':
          label = `${url_key} + ${commodity.name}(${commodity.id}) + ${serviceItem.commodity.product_url_key}`;
          break;
        case 'learn_more_enter':
        case 'learn_more_close':
        case 'learn_more_detail':
          label = `${url_key} + ${commodity.name}(${commodity.id}) + ${serviceItem.product_url_key}`;
          break;
        case 'care_promotion_show':
        case 'care_promotion_click':
        case 'care_promotion_close':
        case 'care_promotion_details':
          label = `${url_key} + ${commodity?.name}(${commodity?.id}) + ${serviceItem?.product_url_key ?? ''}`;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_bind_service`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: care/延保产品页验证序列号模态框埋点
   * @param {string} action 事件操作
   * @param {object} productState 产品状态
   *
   */
  productPageBindServiceSN = ({ action, productState }) => {
    if (!productState) return;
    let label = '';
    let value = '';
    try {
      const {
        productDetail,
        curSelectCommodityId,
        root: {
          area: {
            country: { code },
          },
        },
      } = productState;
      const { url_key, commodities } = productDetail;
      const commodity = commodities.filter((o) => o.id === curSelectCommodityId)[0];
      switch (action) {
        case 'enter':
        case 'focus':
        case 'submit':
        case 'close':
        case 'date':
        case 'step2_submit':
        case 'back_step1':
          label = `${code} _ ${url_key} _ ${commodity.name}(${commodity.id})`;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_bind_service_SN_popup`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页包装清单埋点
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   * @param {object} selectedCommodity 套餐下拉选择切换选中的套餐
   * @param {object} productState 产品状态
   *
   */
  productPageInTheBox = ({ action, eventLabel, productState, selectedCommodity }) => {
    let label = eventLabel || '';
    let value = '';
    try {
      switch (action) {
        case 'toggle_commodity':
          const { productDetail } = productState;
          const commodity = productDetail.commodities.filter((o) => o.id === selectedCommodity.id)[0];
          label = `${productDetail?.name}(${productDetail.id})_${commodity.name}(${commodity.id})`;
          break;
        default:
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_in_the_box`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页对比
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  productPageComparison = ({ action, eventLabel }) => {
    let label = eventLabel || '';
    let value = '';
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_comparison`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页配件适配性
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  productPageCompatibility = ({ action, eventLabel }) => {
    let label = eventLabel || '';
    let value = '';
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_compatibility`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 产品页FAQ
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   *
   */
  productPageFaqs = ({ action, eventLabel, value = '' }) => {
    let label = eventLabel || '';
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_faqs`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: GO2定制
   * @param {string} action 事件操作
   * @param {string} eventLabel 事件标签
   * @param {string} eventValue 事件值
   *
   */
  productPageGO2SkinCustom = ({ action, eventLabel }) => {
    let label = eventLabel || '';
    let value = '';
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_GO2_skin_customization`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @desc flow定制
   * @date 2023/01/30 15:01:42
   * @author haifn
   * @params
   * @return
   */
  productPageCustomSkin = ({ action, eventLabel, key = 'flow' }) => {
    let label = eventLabel || '';
    let value = '';
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_${key}_skin_customization`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 自定义搭配
   * @date 2023/05/17 12:01:42
   */
  productCustomizeYours = ({ action, label = '', value = '', urlKey = '', isEdit = false }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_customize_yours_${urlKey
          .replace(/_/g, '')
          .toUpperCase()}${isEdit ? '_edit' : ''}`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 产品页T恤赠品模块
   * @date 2023/05/17 12:01:42
   */
  extraTShirtGift = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_tshirt`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 产品页Overview
   */
  productOverview = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_overview`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 产品页咨询我们板块-X4
   */
  productChatUs = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_chat_us`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 产品页包装清单弹窗模块
   * @date 2024/04/15
   */
  inTheBoxModal = ({ action, label = '', value = '', productState }) => {
    try {
      const { productDetail = {}, curSelectCommodityId, curSelectCommodity } = productState;
      const { commodities, url_key } = productDetail;
      const commodity = commodities?.filter((o) => o.id === curSelectCommodityId)[0] || curSelectCommodity;
      if (['select_commodity'].includes(action)) {
        label = `${url_key}_${commodity.name}(${commodity.id})`;
      }
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_in_the_box_pop`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @description 产品页套餐弹窗
   * @date 2024/08/08
   */
  bundlePopup = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_bundle_popup`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  productpage_insta360plus = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_cloud_product_page`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.error(e);
    }
  };

  /**
   *
   * @description 产品页客服咨询
   * @date 2024/10/17
   */
  productPageCustomerService = ({ action, label = '', value = '' }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_product_page_online_service`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new ProductTracker();
export default T;
